import { render, staticRenderFns } from "./SecondaryCareCodes.vue?vue&type=template&id=ca5586ae&"
import script from "./SecondaryCareCodes.vue?vue&type=script&lang=js&"
export * from "./SecondaryCareCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports